import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Feed from "./components/Feed";
import EntryGuide from "./components/EntryGuide";
import Zones from "./components/Zones";
import HotPosts from "./components/HotPosts";
import Updates from "./components/Updates";
import Faq from "./components/Faq";
import CtaBanner from "./components/CtaBanner";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <Navbar />
      <main>
        <Hero />
        <Feed />
        <EntryGuide />
        <Zones />
        <HotPosts />
        <Updates />
        <Faq />
        <CtaBanner />
      </main>
      <Footer />
    </div>
  );
}